import { loadBackground, silentLoad, quietLoad } from "@/utils/overlayControl.js";
import { withFieldLoading } from "@/utils/withFieldLoading.js";

export const ProgressiveModuleLoad = {
  data() {
    return {
      tableLoading: false,
    };
  },
  methods: {
    loadPrimary(task) {
      return silentLoad(this, task);
    },
    loadBackground(tasks) {
      return loadBackground(this, tasks);
    },
    loadQuiet(task) {
      return quietLoad(this, task);
    },
    withFieldLoading(flag, task) {
      return withFieldLoading(this, flag, task);
    },
  },
};
